export enum GuestType {
  SENIOR = "SENIOR",
  ADULT = "ADULT",
  TEENAGER = "TEENAGER",
  CHILD = "CHILD",
  BABY = "BABY",
}